import React, { useState, useEffect } from 'react'

import RequestService from 'services/request.service'

import MultiSelectDropdown from 'components/formElements/MultiSelectDropdown'

type SubtypeResponse = {
  subtypename: string
}

type Props = {
  onChange: (values: string[]) => void
  value?: string[]
}

const SubTypeDropdown = ({ value, onChange }: Props) => {
  const [selectedOptions, setSelectedOptions] = useState(value ?? new Array<string>())
  const [options, setOptions] = useState(new Array<{ label: string; value: string }>())

  useEffect(() => {
    RequestService.get<SubtypeResponse[]>(`/api/cards/subtypes/`)
      .then(editions => {
        const options = editions.map(res => ({
          label: res.subtypename,
          searchString: res.subtypename,
          value: res.subtypename,
        }))

        setOptions(options)
      })
      .catch(err => console.error(err))
  }, [])

  // Used to reset the form
  useEffect(() => {
    if (!value || !value?.length) setSelectedOptions([])
  }, [value])

  const handleChange = (selectedOptions: string[]) => {
    setSelectedOptions(selectedOptions)
    onChange(selectedOptions)
  }

  return (
    <MultiSelectDropdown
      searchable
      placeholder="Subtype (eg: Elf)"
      onChange={handleChange}
      options={options}
      value={selectedOptions}
    />
  )
}

export default SubTypeDropdown
